import { Route, Routes } from 'react-router-dom'
import { NotFoundRoute } from 'src/routes/NotFound'
import FeedbackIntro from 'src/routes/FeedbackIntro'
import FeedbackForm from 'src/routes/FeedbackForm'

export function Router() {
    return (
        <Routes>
            <Route path="/feedback-intro" element={<FeedbackIntro />} />
            <Route path="/feedback" element={<FeedbackForm />} />
            <Route path="*" element={<NotFoundRoute />} />
        </Routes>
    )
}
